import { Component, output } from '@angular/core';

@Component({
  selector: 'app-energy-interface-list-section',
  templateUrl: './energy-interface-list-section.html',
})
export class EnergyInterfaceListSection {
  clickCreate = output<string>();
}
